<div class="occupancy ofe-accordion" id="dateSectionWrapper" >
  <ngb-accordion #a="ngbAccordion">
    <ngb-panel id="departure-date-panel">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="occupancy__header">
          <h5 *ngIf="this.innerSelectedDateAsJsDate" class="occupancy__heading">Soluzioni per il
            <strong>
              {{ this.innerSelectedDateAsJsDate | date}}
            </strong>
          </h5>
          <h5 *ngIf="!this.innerSelectedDateAsJsDate" class="occupancy__heading">Nessuna data selezionata ( <strong>{{this.allAvailableDates?.length}}</strong> disponibil{{ this.allAvailableDates?.length === 1 ? 'e' : 'i' }})</h5>
          <div class="occupancy__toggle">

            <!-- Ad Accordion Aperta -->
            <ng-container *ngIf="opened">
              <button class="btn btn--light-blue-outline" ngbPanelToggle>fatto</button>
            </ng-container>

            <!-- Ad Accordion Chiusa -->
            <ng-container *ngIf="!opened">
              <button class="btn btn--light-blue"
                      ngbPanelToggle>{{this.innerSelectedDate ? 'cambia' : 'scegli'}}</button>
            </ng-container>

          </div>
        </div>
      </ng-template>

      <ng-template ngbPanelContent>
        <div class="occupancy__inner">


            <ngb-datepicker #dp="ngbDatepicker" class="datepicker"
                            [(ngModel)]="this.innerSelectedDate"
                            [minDate]="minDate" [maxDate]="maxDate"
                            [displayMonths]="(isMobile$ | async) ? 1 : 2" [navigation]="'select'" [outsideDays]="'visible'"
                            [showWeekNumbers]="false"
                            [markDisabled]="this.isDateUnvailable">

            </ngb-datepicker>


          <hr>

          <div class="row occupancy__row align-items-center">
            <div class="col-sm-6 occupancy__col text-left">
              <button class="btn btn--brand-color-03 occupancy__confirm"
                      (click)="onNewDepartureDateConfirmed()">
                Conferma
              </button>
            </div>
          </div>

        </div>

      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
